import { collapseItems } from "@/mocks/gua";

export default function CollapseField() {
  return (
    <section id="collapsed" className="mx-auto max-w-6xl scroll-mt-28 px-4 py-16 md:px-6 md:py-20">
      {/* 版头 */}
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-medium tracking-[0.3em] text-primary-600">01 / 塌房现场</p>
          <h2 className="mt-3 font-display text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            塌房现场
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            正在发酵的负面新闻逐帧还原：谁塌的、塌在哪、证据链走到哪一步。我们只贴现场，不做定性。
          </p>
        </div>
        <a
          href="#avoidlist"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-100"
        >
          <i className="ri-list-check-2" />
          先查避雷名单
        </a>
      </div>

      {/* 大图卡片流 */}
      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {collapseItems.map((c) => (
          <article
            key={c.id}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
          >
            <div className="relative overflow-hidden bg-background-100">
              <img
                src={c.image}
                alt={`吃瓜黑网塌房现场：${c.title}`}
                title={`${c.title} 塌房现场还原`}
                className="h-56 w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-60"
              />
              <span className="absolute left-3 top-3 flex items-center gap-1 rounded-sm bg-primary-500 px-2 py-1 text-xs font-medium text-background-50">
                <i className="ri-radio-button-line" />
                现场
              </span>
              <span className="absolute right-3 top-3 rounded-sm bg-foreground-950/70 px-2 py-1 text-xs text-background-50 backdrop-blur">
                {c.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-display text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                {c.title}
              </h3>
              <p className="mt-3 text-sm font-medium text-primary-700">{c.lead}</p>
              <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{c.detail}</p>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                  风险 · {c.risk}
                </span>
                <span className="flex items-center gap-1 text-xs text-accent-600">
                  <i className="ri-fire-line" />
                  {c.heat}
                </span>
              </div>
              <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span>{c.happened}</span>
                <span className="flex cursor-pointer items-center gap-1 text-foreground-800 transition-colors group-hover:text-primary-600">
                  查看还原
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}